import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectconfigfileComponent } from './selectconfigfile.component';



@NgModule({
  declarations: [SelectconfigfileComponent],
  exports:[SelectconfigfileComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class SelectconfigfileModule { }
